"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Overview = babelHelpers.interopRequireWildcard(require("tab/Overview"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var ExternalEventOverviewTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ExternalEventOverviewTab, _Component);

  function ExternalEventOverviewTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ExternalEventOverviewTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ExternalEventOverviewTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "locationTitle", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "address", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "description", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "people", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ExternalEventOverviewTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab"
      }, _react.default.createElement("div", {
        className: "stack text"
      }, _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, this.locationTitle || this.address ? _react.default.createElement("div", {
        className: "section"
      }, _react.default.createElement("p", {
        className: "header"
      }, "Location"), this.locationTitle && _react.default.createElement("h3", null, this.locationTitle), this.address && _react.default.createElement("p", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.address)) : null, this.description && _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      }), this.people && _react.default.createElement(_Overview.PeopleList, this.people)))));
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      var pp = _Overview.default.getPeople(object, page, tab);

      if (!pp.people || !object.description || !object.locationTitle || !object.address) {
        return null;
      }

      var order = tab.order,
          title = tab.title,
          includeDiscussion = tab.includeDiscussion,
          id = tab.id;
      return {
        type: 'tab/ExternalEventOverviewTab',
        locationTitle: object.locationTitle,
        address: object.address,
        description: object.description,
        people: pp
      };
    }
  }]);
  return ExternalEventOverviewTab;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "locationTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "address", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ExternalEventOverviewTab;